import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { useTranslate } from '@/shared/lib'
import type { ConfirmType } from './../model/types'

export const useConfirm = defineStore('confirm', () => {
  const { trs } = useTranslate()

  const data = reactive<ConfirmType>({
    show: false,
    loading: false,
    confirmFunc: () => {},
    cancelFunc: () => {},
    title: trs('itf.confirm_title'),
    content: trs('itf.confirm_content'),
  })

  /**
   * Функция показа подтверждения
   * @param confirm
   */
  const show = (confirm: ConfirmType) => {
    data.show = true
    data.confirmFunc = confirm.confirmFunc
    data.cancelFunc = confirm.cancelFunc ?? (() => {})
    data.confirmBtn = confirm.confirmBtn ?? trs('itf.confirm')
    data.cancelBtn = confirm.cancelBtn ?? trs('itf.cancel')

    if (confirm.title !== undefined) data.title = confirm.title
    if (confirm.content !== undefined) data.content = confirm.content
  }

  /**
   * Функция очистки
   */
  const clear = () => {
    data.show = false
    data.loading = false
    data.confirmFunc = () => {}
    data.cancelFunc = () => {}
    data.title = trs('itf.confirm_title')
    data.content = trs('itf.confirm_content')
  }

  /**
   * Функция подтверждения
   * Дожидается выполнения confirmFunc (в т.ч. асинхронного) и закрывает
   * диалог только при успехе. На время выполнения выставляет loading.
   */
  const confirm = async () => {
    if (data.loading) return
    try {
      data.loading = true
      await data.confirmFunc()
      clear()
    } catch {
      /* Ошибку показывает вызывающий код (useNotification); диалог оставляем открытым для повтора */
    } finally {
      data.loading = false
    }
  }

  /**
   * Функция отмены подтверждения
   * Недоступна, пока выполняется подтверждённая операция.
   */
  const cancel = () => {
    if (data.loading) return
    if (data.cancelFunc) data.cancelFunc()
    clear()
  }

  return {
    data,

    show,
    clear,
    confirm,
    cancel,
  }
})
